/**
 * Asynchronously loads the component for PiecripResetPasswordPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripResetPasswordPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripResetPasswordPage,
);
